import React, { ReactNode } from "react";
import Header from "../Header/Header";

const PageContainer: React.FC<{ children?: ReactNode; wide?: boolean }> = ({
  children,
  wide,
}) => {
  const xlMin = wide ? "xl:min-w-[1200px]" : "";

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-200">
      <Header />
      <div
        className={`${xlMin} md:min-w-[700px] sm:min-w-[500px] min-w-[400px] mt-10 max-w-[700px] mb-20`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
